module.exports = __webpack_public_path__ + "media/champions_aura_2014.078e2263.webm";